import React from 'react';

import Typography from 'components/Typography';
import { DateRangeFormatter } from 'intl';

import { IDescriptionDateRange } from './interfaces';

export const DescriptionDateRange: React.FC<IDescriptionDateRange> = ({
  value,
  template = 'LLL',
  timeZone = 'local',
  ...other
}) => {
  return (
    <Typography {...other}>
      <DateRangeFormatter
        value={value}
        template={template}
        timeZone={timeZone}
      />
    </Typography>
  );
};
